import { NumberUtils } from '../../../../utils'

interface DwellTimelineMoment {
    moment: string
    time: number
}

type DwellTimelineData = DwellTimelineMoment[]

export interface DwellTimelineOutput {
    values: string[]
    labels: string[]
    total: number
    perc: number | null
}

interface DwellTimelineReducer {
    values: string[]
    labels: string[]
}

/**
 * Dwell timeline builder
 * @param {object} state
 */
function dwellTimeline(state: DwellTimelineData = []): DwellTimelineOutput {
    let total = 0

    const data = state.reduce(
        (carry: DwellTimelineReducer, row: DwellTimelineMoment) => {
            const { moment = '', time = 0 } = row
            total += time
            return {
                values: [...carry.values, NumberUtils.withDecimalsIfNeeded(time)],
                labels: [...carry.labels, moment],
            }
        },
        { values: [], labels: [] }
    )

    return {
        values: data.values,
        labels: data.labels,
        total: total / data.labels.length,
        perc: null,
    }
}

export default dwellTimeline
